export default __webpack_public_path__ + "static/media/SchedulerOn.9420e6ce.svg";